<template>
    <div class="contactUsForm">
        <div class="formHead">
            <div class="headText">{{ title }}</div>
        </div>
        <div class="formBox">
            <el-form hide-required-asterisk label-position="top" :model="formData" :rules="rules" ref="ruleForm"
                class="demo-ruleForm">
                <div class="formOne">
                    <div class="oneItem">
                        <el-form-item :label="$t('i18n_118')" prop="name">
                            <el-input v-model="formData.name"></el-input>
                        </el-form-item>
                    </div>
                    <div class="oneItem">
                        <el-form-item :label="$t('i18n_119')" prop="email">
                            <el-input v-model="formData.email"></el-input>
                        </el-form-item>
                    </div>
                    <div class="oneItem">
                        <el-form-item :label="$t('i18n_120')" prop="country">
                            <el-input v-model="formData.country"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="formTwo">
                    <div class="telephone">
                        <el-form-item :label="$t('i18n_121')" prop="telephone">
                            <el-input v-model="formData.telephone"></el-input>
                        </el-form-item>
                    </div>
                    <div class="company">
                        <el-form-item :label="$t('i18n_122')" prop="company">
                            <el-input v-model="formData.company"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="formItemRow">
                    <el-form-item :label="$t('i18n_123')" prop="address">
                        <el-input v-model="formData.address"></el-input>
                    </el-form-item>
                </div>
                <div class="formItemRow">
                    <el-form-item :label="$t('i18n_124')" prop="message">
                        <el-input style="font-size: 16px;" type="text" :autosize="{ minRows: 1, }" v-model="formData.message"></el-input>
                    </el-form-item>
                </div>
                <el-form-item style="display: flex;justify-content: center;margin-top: 79px;">
                    <el-button @click="submitChange" :loading="loading" style="width: 312px;height: 60px;background: #000000;font-size: 24px;
color: #FFFFFF;">{{ $t('i18n_125') }}</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { sub_message } from '@/api/contact'
export default {
    components: {

    },
    data() {
        return {
            title: '',
            formData: {
                name: '',
                email: '',
                country: '',
                telephone: '',
                company: '',
                address: '',
                message: '',
            },
            loading: false,
            rules: {
                name: [
                    { required: true, message: this.$t('i18n_126'), trigger: ['blur', 'change'] },
                ],
                email: [
                    { required: true, message: this.$t('i18n_127'), trigger: ['blur', 'change'] },
                ],
                country: [
                    { required: true, message: this.$t('i18n_128'), trigger: ['blur', 'change'] },
                ],
                telephone: [
                    { required: true, message: this.$t('i18n_129'), trigger: ['blur', 'change'] },
                ],
                company: [
                    { required: true, message: this.$t('i18n_130'), trigger: ['blur', 'change'] },
                ],
                address: [
                    { required: true, message: this.$t('i18n_131'), trigger: ['blur', 'change'] },
                ],
                message: [
                    { required: false, message: this.$t('i18n_132'), trigger: ['blur', 'change'] },
                ],
            }
        }
    },
    created() {
        this.$bus.$on('setContactTitle', (data) => {
            this.title = data
        })
    },
    mounted() {

    },
    beforeDestroy() {
        this.$bus.$off('setContactTitle')
    },
    methods: {
        submitChange() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    sub_message(this.formData).then(res => {
                        this.$notify({
                            title: this.$t('i18n_133'),
                            message: this.$t('i18n_134'),
                            type: 'success'
                        })
                        this.$refs.ruleForm.resetFields()
                    }).finally(() => {
                        this.loading = false
                    })
                }
            })
        },
    }
}
</script>

<style scoped lang="scss">
.contactUsForm {
    width: 1200px;
    background: #fff;
    margin: auto;
    transform: translate(0, -150px);
    position: relative;
    z-index: 99;

    .formHead {
        padding: 40px 20px;
        border-bottom: 1px solid #888888;
        background: #fff;
        height: 150px;
        box-sizing: border-box;

        .headText {
            font-size: 22px;
            color: #010101;
            line-height: 30px;
            text-align: center;
            white-space: pre-wrap;
        }
    }

    .formBox {
        padding: 0 100px;

        .demo-ruleForm {
            margin-top: 60px;

            .formOne {
                display: flex;
                justify-content: space-between;
                gap: 30px;

                .oneItem {
                    flex: 1;
                }
            }

            .formTwo {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 30px;

                .telephone {
                    flex: 1;
                }

                .company {
                    flex: 2;
                }
            }

            .formItemRow {}
        }
    }
}

::v-deep .formBox .el-form-item__label {
    font-size: 20px;
    font-weight: 300;
}

::v-deep .formBox .el-form-item {
    margin-bottom: 60px;
}

::v-deep .formBox .el-input__inner {
    border-radius: 0px;
    border-top: 0px;
    border-left: 0px;
    border-right: 0px;
    border-bottom: 1px solid #888888;
    font-size: 16px;
    padding-left: 0px;
    padding-right: 0px;
    min-height: 50px;
}

::v-deep .formBox .el-textarea__inner {
    border-radius: 0px;
    border-top: 0px;
    border-left: 0px;
    border-right: 0px;
    border-bottom: 1px solid #888888;
}

@media screen and (max-width:1200px) {
    .contactUsForm {
        width: 100%;
        background: #fff;
        margin: auto;
        transform: translate(0, 0);
        position: relative;
        z-index: 99;

        .formHead {
            padding: 40px 20px;
            border-bottom: 1px solid #888888;
            background: #fff;
            height: auto;

            .headText {
                font-size: 16px;
                line-height: 24px;
                color: #010101;
                text-align: center;
                white-space: pre-wrap;
                word-break: break-word;
            }
        }

        .formBox {
            padding: 0 20px;

            .demo-ruleForm {
                margin-top: 60px;

                .formOne {
                    display: block;
                }

                .formTwo {
                    display: block;

                }

            }
        }
    }
}
</style>